import React from 'react';
import './AccountLayout.css';

const AccountPlaceholder = ({ title, hint, children }) => (
  <div className="account-page">
    <h1>{title}</h1>
    <p className="account-page__muted">
      {hint ||
        'This section is not fully available on the web yet. You can continue in the DigiRasa app, or check back soon.'}
    </p>
    {children}
  </div>
);

export default AccountPlaceholder;
